
import { JitsiController } from '@/service/JitsiLibWrapper';
import { RoomConnectionManager } from '@/service/RoomConnectionManager';
import { CoordinatesPosition, zawaroom } from '@/utils/models';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class ConnectionDebugger extends Vue {
  top = 10;
  right = 200;

  private startPos: CoordinatesPosition = { x: 0, y: 0 };
  private mouseStartPos: CoordinatesPosition = { x: 0, y: 0 };
  manager: RoomConnectionManager | null = null;
  get isDebugMode(): boolean {
    return this.$store.state.isDebugMode;
  }

  get connection(): JitsiController | null {
    if (zawaroom.jitsi) {
      return zawaroom.jitsi.currentAVConnection;
    }
    return null;
  }
  @Watch('isDebugMode')
  setup(debug: boolean) {
    if (!debug) {
      return;
    }
    this.$nextTick().then(() => {
      let el = this.$refs.container as HTMLDivElement;
      el.addEventListener('pointerdown', this.onPointerDownHandler);
      el.addEventListener('pointerup', this.onPointerUpLeaveHandler);
      el.addEventListener('pointerleave', this.onPointerUpLeaveHandler);
    });
  }
  mounted() {
    this.onPointerDownHandler = this.onPointerDownHandler.bind(this);
    this.onPointerUpLeaveHandler = this.onPointerUpLeaveHandler.bind(this);
    this.onPointerUpLeaveHandler = this.onPointerUpLeaveHandler.bind(this);
    this.$nextTick().then(() => {
      this.manager = zawaroom.jitsi ?? null;
    });
  }
  beforeDestroy() {
    let el = this.$refs.container as HTMLDivElement;
    if (!el) {
      return;
    }
    el.removeEventListener('pointerdown', this.onPointerDownHandler);
    el.removeEventListener('pointerup', this.onPointerUpLeaveHandler);
    el.removeEventListener('pointerleave', this.onPointerUpLeaveHandler);
  }
  //#region パンの処理
  private onPointerDownHandler(e: PointerEvent) {
    e.stopPropagation();
    const el = this.$refs.container as HTMLDivElement;
    el.addEventListener('pointermove', this.onMouseMoveHandler);
    el.setPointerCapture(e.pointerId);
    this.startPos.x = this.right;
    this.startPos.y = this.top;
    this.mouseStartPos.x = e.x;
    this.mouseStartPos.y = e.y;
  }
  private onPointerUpLeaveHandler(e: PointerEvent) {
    const el = this.$refs.container as HTMLDivElement;
    el.removeEventListener('pointermove', this.onMouseMoveHandler);
    el.releasePointerCapture(e.pointerId);
  }
  private onMouseMoveHandler(e: PointerEvent) {
    e.stopPropagation();
    this.top = this.startPos.y + e.y - this.mouseStartPos.y;
    this.right = this.startPos.x - e.x + this.mouseStartPos.x;
  }
  //#endregion
}
